export class NoProductError extends Error {
  constructor() {
    super('No product was selected.')
  }
}
